import type { MessageKey } from "./en";

// TODO:i18n — machine-translated placeholders, review with native speaker.
export const zh: Partial<Record<MessageKey, string>> = {
  "nav.home": "首页",
  "nav.repos": "代码库",
  "nav.issues": "新手任务",
  "nav.developers": "开发者",
  "nav.submit": "提交你的项目",

  "common.loading": "加载中…",
  "common.error": "出错了",
  "common.retry": "重试",
  "common.search": "搜索",

  "hero.title": "KuberCoin 开源平台",
  "hero.subtitle": "在 KuberCoin 生态中发现、贡献和资助开源项目。",
  "hero.cta_browse": "浏览项目",
  "hero.cta_submit": "提交你的项目",

  "repos.stars": "星标",
  "repos.forks": "分叉",
  "repos.language": "语言",

  "footer.copyright": "© 2026 KuberCoin 开源",
  "footer.license": "在 MIT 许可证下发布。",

  "nav.playground": "实验场",
  "nav.changelog": "更新日志",
  "nav.apiDocs": "API 文档",
  "nav.contributors": "贡献者",
  "nav.devLogin": "开发者登录",
  "nav.admin": "管理",
  "nav.logout": "退出",

  "search.title": "搜索",
  "search.placeholder": "搜索仓库、文件、提交…",
  "search.button": "搜索",
  "search.filter.all": "全部",
  "search.filter.repos": "仓库",
  "search.filter.files": "文件",
  "search.filter.submissions": "提交",
  "search.type.repository": "仓库",
  "search.type.file": "文件",
  "search.type.submission": "提交",
  "search.empty": "未找到结果。请尝试其他搜索词。",

  "notifications.title": "通知",
  "notifications.markAllRead": "全部标为已读",
  "notifications.markRead": "标为已读",
  "notifications.empty": "暂无通知。",

  "contributors.title": "贡献者",
  "contributors.subtitle": "认识构建 KuberCoin 开源生态的开发者们。",
  "contributors.searchPlaceholder": "搜索贡献者…",
  "contributors.sort.activity": "最活跃",
  "contributors.sort.newest": "最新",
  "contributors.sort.oldest": "最早",
  "contributors.sort.name": "姓名 A–Z",
  "contributors.emptySearch": "没有匹配的贡献者。",
  "contributors.empty": "暂无贡献者。",

  "pagination.previous": "上一页",
  "pagination.next": "下一页",

  "rateLimit.slowDown": "请求频率超限 — 请稍后再试",

  "notFound.title": "页面未找到",
  "notFound.message": "您查找的页面不存在或已被移动。",
  "notFound.home": "返回首页",

  "settings.title": "设置",
  "settings.theme": "主题",
  "settings.themeDescription": "选择您偏好的颜色主题。",
  "settings.switchToLight": "切换至浅色",
  "settings.switchToDark": "切换至深色",
  "settings.language": "语言",
  "settings.languageDescription": "选择您偏好的语言。",
  "settings.notifications": "通知",
  "settings.emailNotifications": "邮件通知",

  // --- Session ---
  "session.expired": "您的会话已过期，请重新登录。",

  // --- Offline ---
  "offline.banner": "您当前处于离线状态，部分功能可能不可用。",

  // --- Shortcuts ---
  "shortcuts.title": "键盘快捷键",
  "shortcuts.hint": "按 ? 切换此对话框",

  "activity.title": "活动动态",
  "activity.subtitle": "KuberCoin 开源生态系统中的近期活动。",
  "activity.empty": "暂无近期活动。",

  "issues.title": "新手任务",
  "issues.subtitle": "寻找适合初学者的问题，开始贡献。",
  "issues.empty": "目前没有开放的问题。",
  "issues.difficulty.all": "全部",
  "issues.difficulty.beginner": "初级",
  "issues.difficulty.intermediate": "中级",
  "issues.viewRepo": "查看仓库",

  "apiDocs.title": "API 文档",
  "apiDocs.subtitle": "探索 KuberCoin 开放 API 规范。",
  "apiDocs.loading": "加载 API 规范中…",
  "apiDocs.error": "加载 API 规范失败。",

  "time.justNow": "刚刚",
  "time.minutesAgo": "{n}分钟前",
  "time.hoursAgo": "{n}小时前",
  "time.daysAgo": "{n}天前",

  "empty.generic": "暂无内容。",
  "empty.noResults": "未找到结果。",
};
